import { QueryClient, dehydrate, hydrate } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreloadStaleTime: 0,
    // Serialize successful loader-fetched queries into the SSR payload and
    // restore them into the client cache on hydration. Without this bridge
    // the server renders with query data the client doesn't have, producing
    // hydration mismatches (React #418) and duplicate first-paint fetches.
    // DehydratedState is JSON-serializable at runtime; cast around the
    // router's exactOptionalPropertyTypes serializability validator.
    dehydrate: () => ({ queryClientState: dehydrate(queryClient) }) as any,
    hydrate: (dehydrated: any) => {
      hydrate(queryClient, dehydrated.queryClientState);
    },
  });

  return router;
};

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}